/* eslint-disable */
import React, { useState, useCallback } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAuth } from '../Context/AuthContext';

const apiUrl = process.env.REACT_APP_API_URL;

const LoginForm = ({ formik, loading }) => {
  const { t } = useTranslation();

  return (
    <form onSubmit={formik.handleSubmit} className="max-w-sm mx-auto">

      {/* Email Input */}
      <div className="flex items-center mb-4">
        <input
          type="email"
          name="email"
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          className="py-2.5 px-4 text-sm font-medium text-gray-900 bg-white border border-gray-300 rounded-lg focus:ring-4 focus:outline-none focus:ring-gray-100 dark:bg-gray-800 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-gray-700"
          placeholder={t('enterEmail')}
          style={{ height: '50px', width: '100%' }}
          disabled={loading}
        />
      </div>
      {formik.touched.email && formik.errors.email && (
        <div className="text-red-500 text-sm mb-4">{formik.errors.email}</div>
      )}

      {/* Order Number Input */}
      <div className="flex items-center mb-4">
        <input
          type="text"
          name="orderNumber"
          value={formik.values.orderNumber}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          className="py-2.5 px-4 text-sm font-medium text-gray-900 bg-white border border-gray-300 rounded-lg focus:ring-4 focus:outline-none focus:ring-gray-100 dark:bg-gray-800 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-gray-700"
          placeholder={t('enterOrderNumber')}
          style={{ height: '50px', width: '100%' }}
          disabled={loading}
        />
      </div>
      {formik.touched.orderNumber && formik.errors.orderNumber && (
        <div className="text-red-500 text-sm mb-4">{formik.errors.orderNumber}</div>
      )}

      <button
        type="submit"
        className={`w-full py-2 bg-black text-white rounded-md ${loading ? 'opacity-50 cursor-not-allowed' : 'hover:cursor-pointer'}`}
        disabled={loading}
      >
        <div className="flex items-center justify-center">
          <span>{loading ? t('loading') : t('access')}</span>
        </div>
      </button>
    </form>
  );
};

export const LoginPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const validationSchema = Yup.object({
    email: Yup.string()
      .email(t('invalidEmail'))
      .required(t('emailRequired')),
    orderNumber: Yup.string()
      .required(t('orderNumberRequired'))
      .test(
        'not-a-url',
        t('cannotBeUrl'),
        value => {
          const trimmedValue = value.trim();
          const urlRegex = /^(https?:\/\/(?:www\.)?[^\s$.?#].[^\s]*$)/;
          const simpleUrlRegex = /^(?!\s*$)(\S+\.\S+|\S+\.\S+\.\S+)(?!\S)/;
          const invalidContentRegex = /(\S+\.\S+.*[^\s])$/;
          return !urlRegex.test(trimmedValue) && !simpleUrlRegex.test(trimmedValue) && !invalidContentRegex.test(trimmedValue);
        }
      )
  });

  const formik = useFormik({
    initialValues: {
      email: '',
      orderNumber: ''
    },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        // Updated payload to use email instead of phoneNumber
        const response = await axios.post(`${apiUrl}/login`, {
          email: values.email,
          order_number: values.orderNumber
        });
        toast.success(t(response?.data?.message));
        login(response?.data?.orderId, values.email);
        setTimeout(() => navigate('/otp'), 1000);
      } catch ({ response }) {
        toast.error(t(response?.data?.message));
      } finally {
        setLoading(false);
      }
    }
  });

  const handleSubmit = useCallback((e) => {
    e.preventDefault();
    formik.handleSubmit();
  }, [formik]);

  return (
    <>
      <ToastContainer />
      <div className="flex justify-center items-center p-4" style={{ minHeight: '50vh' }}>
        <div className="text-gray-600 text-xl">
          <div className="flex flex-col justify-center items-center text-[#636362]">
            <div className="flex items-center mb-10">
              <span className="text-bold text-[#FF0000] px-2">*</span>
              <p className="text-black text-lg">{t('enterEmailAndOrderNumber')}</p>
            </div>
            <LoginForm formik={formik} loading={loading} />
          </div>
        </div>
      </div>
    </>
  );
};